export const SET_ALL = 'SET_ALL';
export const ADD_LOGIN_HISTORY_DATA_ALL = 'ADD_LOGIN_HISTORY_DATA';
export const LESS_LOGIN_HISTORY_DATA_ALL = 'LESS_LOGIN_HISTORY_DATA_ALL';
